import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/project/$projectId/tender-packages/$')({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: location.href.replace('/tender-packages/', '/workspaces/'),
      replace: true,
    });
  },
});
